import { render, staticRenderFns } from "./ConsignmentSummaryReportAmtTableTH.vue?vue&type=template&id=30de8086&scoped=true"
import script from "./ConsignmentSummaryReportAmtTableTH.vue?vue&type=script&lang=js"
export * from "./ConsignmentSummaryReportAmtTableTH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de8086",
  null
  
)

export default component.exports